import styled from 'styled-components';

// Samsung
export const StyledSamsungCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const StyledSamsungCardImageBox = styled.div`
  margin-top: 350px;
  display: flex;
  justify-content: center;

  > img {
    width: 300px;
    height: 300px;
    border-radius: 8px;
    object-fit: cover;
    background-color: #c1c1c1;
    border: 1px solid #e0e0e0;
  }
`;

export const StyledSamsungCardUserName = styled.div`
  display: flex;
  justify-content: center;
  font-weight: 700;
  font-size: 53px;
  margin-bottom: 30px;
`;

export const StyledCardContainer = styled.div`
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  border-radius: 8px;
  overflow: hidden;
  font-size: 33px;
`;

export const StyledCardRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;

  &:last-child {
    border-bottom: none;
  }
`;

export const StyledCardCell = styled.div`
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StyledCardText = styled.span`
  text-align: left;

  img {
    object-fit: cover;
    margin-left: 8px;
    border: 1px solid rgba(203, 203, 203, 1);
    border-radius: 4px;
  }

  &.label {
    color: #7d7d80;
    white-space: nowrap;
  }
`;
